<template>
  <div class="overlay card">
    <div class="container">
      <div class="brand-logo">
        <img src="@/assets/logo-indosuez.svg" alt="chrome logo" height="150" width="150" />
        <img src="@/assets/CAnnectLogo.svg" alt="chrome logo" height="150" width="150" />
      </div>
      <img src="@/assets/chrome.svg" alt="chrome logo" height="50" width="50" />
      <div class="text-container">
        <p>
          It seems that you are using a web browser version that we do not support.
          <br />
          <span class="bold">Please use Chrome to get the most out of the CAnnect experience.</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrowserSupport'
}
</script>

<style scoped lang="scss">
@media only print {
  .card {
    position: static !important;
    overflow: visible !important;
  }
}

.overlay {
  opacity: 1;
  background-color: #f2f2f2;
  width: 100%;
  height: 100%;
  z-index: 1;

  &.card {
    position: fixed;
    top: 0;
    left: 0;
    overflow: auto;
    z-index: 3;
  }
}

.link {
  color: $primary-color;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.bold {
  font-weight: 900;
}

.brand-logo {
  margin: auto;

  * {
    margin: 0 20px;
  }
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  width: 500px;
  margin-top: 30px;
  padding: 30px 60px;

  background-color: white;
  box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);
  border-radius: 2px;

  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);

  .text-container {
    width: 500px;
    text-align: center;
    text-justify: inter-word;
    color: $black-color;
  }
}
</style>
